// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","main":"_3abGed","mainUpper":"IUxBYE","hoverRating":"__SPpy","mainLower":"CG9_Vc"};